var map = {
	"./bg.jpg": "e7a6",
	"./图表区.jpg": "e2a9",
	"./报表区.jpg": "7c61",
	"./指标区.jpg": "908c",
	"./时间轴.jpg": "e2ef",
	"./照片墙.jpg": "5bac",
	"./统计区.jpg": "5f92",
	"./通知公告.jpg": "8b46"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07b2";